export enum PathnameEnum {
  ERROR_404 = '/404',

  USER_PROFILE = '/users/:id',

  CONVERSATION_COMPOSE = '/messages/compose',
  CONVERSATION_COMPOSE_GROUP = '/messages/compose/group',
  CONVERSATION_COMPOSE_PRIVATE = '/messages/compose/private',
  CONVERSATION_DETAILS = '/messages/:id/:slug?', // ?messageId
  CONVERSATION_EDIT = '/messages/:id/edit',
  CONVERSATION_FEATURE_PREVIEW = '/messages/preview',
  CONVERSATION_ROOT = '/messages',
  CONVERSATION_SEARCH = '/messages/search', // ?query
  CONVERSATION_SPLAT = '/messages/*',
  CONVERSATION_START = '/messages/start', // ?userId

  ROOT = '/',

  SPLAT = '*',
}

export type PathParams = {
  [PathnameEnum.USER_PROFILE]: {
    params: {
      id: ID;
    };
  };
  [PathnameEnum.CONVERSATION_DETAILS]: {
    params: {
      id: ID;
      slug?: string;
    };
    queryParams?: {
      messageId?: ID;
    };
  };
  [PathnameEnum.CONVERSATION_EDIT]: {
    params: {
      id: ID;
    };
  };
  [PathnameEnum.CONVERSATION_SEARCH]: {
    queryParams: {
      query: string;
    };
  };
  [PathnameEnum.CONVERSATION_START]: {
    queryParams: {
      userId: ID | ID[];
    };
  };
};
